
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form2DataInfoType } from '@/types/Information/Form2';

@Component
export default class Form2Layout extends Vue {

    @Prop({required:true})
    result!: form2DataInfoType;
   
}

